(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["captain-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('captain-gallery')){
  customElements.define('captain-gallery',class extends HTMLElement{
    connectedCallback(){
      this.slides=[...this.querySelectorAll('.captain-gallery__slide')];
      if(this.slides.length<2)return;
      this.track=this.querySelector('.captain-gallery__slides');
      this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered=false;this.focused=false;
      this.toggle=this.querySelector('[data-toggle]');
      this.querySelector('.captain-gallery__controls').hidden=false;
      this.abort=new AbortController();
      const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.abort.signal});
      on(this.querySelector('[data-prev]'),'click',()=>this.show(this.index-1));
      on(this.querySelector('[data-next]'),'click',()=>this.show(this.index+1));
      this.querySelectorAll('[data-slide]').forEach(b=>on(b,'click',()=>this.show(Number(b.dataset.slide))));
      on(this.toggle,'click',()=>{this.paused=!this.paused;this.sync();});
      on(this,'mouseenter',()=>{this.hovered=true;this.sync();});
      on(this,'mouseleave',()=>{this.hovered=false;this.sync();});
      on(this,'focusin',()=>{this.focused=true;this.sync();});
      on(this,'focusout',()=>{setTimeout(()=>{this.focused=this.contains(document.activeElement);this.sync();},0);});
      on(document,'visibilitychange',()=>this.sync());
      this.resize=new ResizeObserver(()=>this.position(false));this.resize.observe(this);
      this.show(0);
    }
    position(smooth){
      const first=this.slides[0],last=this.slides[this.slides.length-1];
      this.track.style.paddingLeft=Math.max(0,(this.track.clientWidth-first.offsetWidth)/2)+'px';
      this.track.style.paddingRight=Math.max(0,(this.track.clientWidth-last.offsetWidth)/2)+'px';
      const slide=this.slides[this.index];
      const left=slide.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft-(this.track.clientWidth-slide.offsetWidth)/2;
      this.track.scrollTo({left,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
    }
    show(index){
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{slide.hidden=false;slide.setAttribute('aria-hidden',String(i!==this.index));slide.inert=i!==this.index;});
      this.position(true);
      this.querySelectorAll('[data-slide]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
      this.sync();
    }
    sync(){
      clearInterval(this.timer);
      this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause;
      if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden)
        this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.delay)||6000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
